import { render, staticRenderFns } from "./CaseDetailEvents.vue?vue&type=template&id=153bc1ba&"
import script from "./CaseDetailEvents.vue?vue&type=script&lang=js&"
export * from "./CaseDetailEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports